import { render, staticRenderFns } from "./Api.vue?vue&type=template&id=1fde1020&scoped=true"
import script from "./Api.vue?vue&type=script&lang=js"
export * from "./Api.vue?vue&type=script&lang=js"
import style0 from "./Api.vue?vue&type=style&index=0&id=1fde1020&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fde1020",
  null
  
)

export default component.exports